// custom hook para solicitar la data inicial de los equipos y clientes

import { useState, useEffect, useContext } from "react";



// app config importation
import { TOUR_TOKEN, NAME_LAST_LOC, AUTH_TOKEN_NAME } from "../../config/appConf.js";


// url importation
import { urls } from "../../api-urls/api-urls.js";


import { LangContext } from "../../context/LangContext.jsx";


import { useNavigate } from "react-router-dom";










export const useFetchInfo = (location = {}, userCont = {}, id_eqp = "") => {

  // console.log(LANGUAGE)
  const { lang } = useContext(LangContext);

  // state definition
  const [equipment, setEquipment] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [pendingServ, setPendingServ] = useState([]);
  const [controller, setController] = useState(null); // controlador para cancelar la data al servidor
  const [state, setState] = useState({ isLoading: false, dataVisible: false, modalLogin: false, sending: false, modalTour: false, equip: 0, custo: "", modalPend: false });

  const navigate = useNavigate();

  // send data to server
  const onHandleChangeSending = (value = false) => {
    setState((val) => ({ ...val, sending: value }))
  };


  // funcion para cerrar el modal de las llamadas pendientes
  const onCloseServPend = () => {
    setState((val) => ({ ...val, modalPend: false }));
  };

  // console.log(id_eqp)

  // funcion para solicitar la data al servidor
  const fetchDataServ = async () => {

    const abortController = new AbortController();

    setController(abortController);


    const END_POINT = `${urls.serviceEquipments}/${userCont?.CodCliente}?uuid=${id_eqp ?? ""}&lang=${lang}&email=${userCont?.Correo}`;

    const AUTH_TOKEN = localStorage.getItem(AUTH_TOKEN_NAME);

    try {
      setState((val) => ({ ...val, isLoading: true }));
      const response = await fetch(END_POINT, {
        headers: {
          "Authorization": AUTH_TOKEN,
          "Content-Type": "application/json"
        },
        signal: abortController.signal
      });

      const data = await response.json();


      if (response.status === 200) {
        setEquipment(data?.equipments);
        setCustomer(data?.customer);
        if ((data?.pendingServ && data?.pendingServ.length > 0) && id_eqp !== null) {
          setPendingServ(data?.pendingServ);
          setState((val) => ({ ...val, modalPend: true }));
        }
        setState((val) => ({ ...val, dataVisible: true, modalLogin: false }));
      } else if (response.status === 401) {

        if (id_eqp !== "" && id_eqp) {
          setState((val) => ({ ...val, dataVisible: false, modalLogin: true }));
          localStorage.setItem(NAME_LAST_LOC, JSON.stringify(location));
        } else {
          return navigate("/");
        }

      }

      setState((val) => ({ ...val, isLoading: false }));

    } catch (error) {
      console.error(error);
    }
  };


  // useEffect para solicitar la data al servidor
  useEffect(() => {

    // if (Object.keys(userCont).length > 0) {

      fetchDataServ();

      return () => {
        if (controller) {
          controller.abort();
        }
      };

    // }

  }, [lang, userCont, id_eqp]);


  // useEffect para filtrar el equipo por el uid
  useEffect(() => {

    if ((id_eqp !== "" && id_eqp) && (equipment && equipment.length > 0)) {

      const { CodEquipo, CodCliente } = equipment && equipment.find((findEqp) => {
        return findEqp.UUIDLink && String(findEqp.UUIDLink) === String(id_eqp);
      });

      setState((val) => ({ ...val, equip: CodEquipo, custo: CodCliente }));

    }

  }, [equipment, id_eqp]);


  // useEffect para obtener el valor del localStorage
  useEffect(() => {
    if (TOUR_TOKEN) {

    } else {
      // sino existe abrir el modal
      // setState((val) => ({...val, modalTour: true}));
    }
  }, []);




  return {
    state,
    equipment,
    customer,
    pendingServ,
    onHandleChangeSending,
    onCloseServPend
  };
};